import { makeStyles } from "@material-ui/core";

export const useFollowerRequestsModalStyles = makeStyles(() => ({
    dialog: {
        "& .MuiDialogTitle-root": {
            borderBottom: "none"
        }
    }
}));
